<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
  <path d="M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM16.22 12.46L10.64 16.58C10.26 16.86 9.74 16.58 9.74 16.12V7.88C9.74 7.42 10.26 7.16 10.64 7.42L16.22 11.54C16.52 11.78 16.52 12.22 16.22 12.46Z"/>
</svg>
